module.exports = __webpack_public_path__ + "media/day/320-f4e044b5.svg";